module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "基础信息",
      "shadow": "naver"
    }
  }, [_c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动banner",
      "hide-requied-aterisk": "true"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgPicker
    }
  }, [(_vm.form.banner) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.banner
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "title"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 80,
      "placeholder": "活动名称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动说明",
      "prop": "title"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 200,
      "placeholder": "活动说明"
    },
    model: {
      value: (_vm.form.activity_explain),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_explain", $$v)
      },
      expression: "form.activity_explain"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "每限领商品数量",
      "prop": "title"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input-number', {
    attrs: {
      "type": "number",
      "placeholder": "限领商品数"
    },
    model: {
      value: (_vm.form.limit_items_nums),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_items_nums", $$v)
      },
      expression: "form.limit_items_nums"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否限制总人数"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.limit_user_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_user_type", $$v)
      },
      expression: "form.limit_user_type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动总人数",
      "prop": "title"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input-number', {
    attrs: {
      "type": "number",
      "placeholder": "活动总人数"
    },
    model: {
      value: (_vm.form.limit_user_nums),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_user_nums", $$v)
      },
      expression: "form.limit_user_nums"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "选择赠品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "店铺",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用店铺"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.shopTypeChange
    },
    model: {
      value: (_vm.form.use_all_shops_flag),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_all_shops_flag", $$v)
      },
      expression: "form.use_all_shops_flag"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全部适用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    }
  }, [_vm._v("指定店铺适用")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDistributorAction
    }
  }, [_vm._v("选择店铺")]), _vm._v(" "), (_vm.distributor_info.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.distributor_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "distributor_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteDistritutorRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 3521329561)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('StoreSelect', {
    attrs: {
      "store-visible": _vm.storeVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relShopIds,
      "get-status": _vm.setStatus
    },
    on: {
      "chooseStore": _vm.chooseStoreAction,
      "closeStoreDialog": _vm.closeStoreDialogAction
    }
  }), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.distributorVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relDistributorIds,
      "get-status": _vm.setDistributorStatus
    },
    on: {
      "chooseStore": _vm.chooseDistributorAction,
      "closeStoreDialog": _vm.closeDistributorDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3af0bf37", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af0bf37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/giftsactivity/add.vue
// module id = 2632
// module chunks = 0